import React from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import RefineAuthorizationListResponsiveTableRowCell from './RefineAuthorizationListResponsiveTableRowCell';
import RefineAuthorizationListActionCell from './RefineAuthorizationListActionCell';
import { TableCellStickyColumn } from '../../../../../components/list/TableComponentsStyled';

const RefineAuthorizationListResponsiveTableRow = props => {
  const { userGroups, authorization, documentState, dispatch, authorizationRefineChangedPermissions } = props;

  const documentTypeId =
    authorizationRefineChangedPermissions[documentState.documentTypeId] !== undefined
      ? authorizationRefineChangedPermissions[documentState.documentTypeId].documentTypeId
      : undefined;
  const documentStateId =
    documentTypeId !== undefined &&
    authorizationRefineChangedPermissions[documentState.documentTypeId][documentState.documentStateId] !== undefined
      ? authorizationRefineChangedPermissions[documentState.documentTypeId][documentState.documentStateId].documentStateId
      : undefined;
  const getCanRefinePermission = (documentTypeId, documentStateId, userGroup) => {
    let newRefineChangedPermissions = undefined;
    if (
      documentStateId !== undefined &&
      documentTypeId !== undefined &&
      userGroup !== undefined &&
      authorizationRefineChangedPermissions[documentTypeId][documentStateId][userGroup.id] !== undefined
    )
      newRefineChangedPermissions = authorizationRefineChangedPermissions[documentTypeId][documentStateId][userGroup.id];
    return newRefineChangedPermissions;
  };
  return (
    <TableRow hover>
      <TableCellStickyColumn>{`${documentState.documentTypeName} - ${documentState.documentStateName}`}</TableCellStickyColumn>
      <RefineAuthorizationListActionCell documentState={documentState} userGroups={userGroups} dispatch={dispatch} />
      {userGroups?.map(userGroup => (
        <RefineAuthorizationListResponsiveTableRowCell
          key={documentState.documentTypeId + '_' + documentState.documentStateId + '_' + userGroup.id}
          userGroup={userGroup}
          documentState={documentState}
          dispatch={dispatch}
          changedRefinePermission={getCanRefinePermission(documentTypeId, documentStateId, userGroup)}
          authorization={authorization}
        />
      ))}
    </TableRow>
  );
};

RefineAuthorizationListResponsiveTableRow.propTypes = {
  userGroups: PropTypes.array.isRequired,
  authorization: PropTypes.object.isRequired,
  documentState: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  authorizationRefineChangedPermissions: PropTypes.object.isRequired
};

export default RefineAuthorizationListResponsiveTableRow;
